import './Hashtag.css'

const Hashtag = ({ children }: any) => {
  return (
    <span className="hashtag">
      {children}
    </span>
  )
}

export default Hashtag
